import { render, staticRenderFns } from "./ServerGood.vue?vue&type=template&id=70d3b881&scoped=true&"
import script from "./ServerGood.vue?vue&type=script&lang=js&"
export * from "./ServerGood.vue?vue&type=script&lang=js&"
import style0 from "./ServerGood.vue?vue&type=style&index=0&id=70d3b881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3b881",
  null
  
)

export default component.exports